import { useState, useEffect } from "react";
import { getUserPackage } from "../../Services";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { Col, Row, Tag, List, Typography } from "antd";
import { MazakaButton } from "apps/Common/MazakaButton";

import {
  ArrowLeftOutlined,
  EditOutlined,
  PlusOutlined,
  SwapRightOutlined,
} from "@ant-design/icons";
import Package from "./Package";
import dayjs from "dayjs";
import PriceFormatter from "apps/Common/PriceFormatter";

const { Text } = Typography;

const CurrentPackage = () => {
  const [packageList, setPackageList] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isShowAllPackages, setIsShowAllPackages] = useState(false);

  useEffect(() => {
    getCurrentPackage();
  }, []);

  const getCurrentPackage = async () => {
    setIsLoading(true);
    try {
      const response: any = await getUserPackage();
      if (response?.data) {
        let data = response.data.map((item: any) => {
          if (item?.package) {
            return { ...item?.package, ...item, inUser: true };
          }
          return item;
        });
        if (response?.data?.length <= 0) {
          setIsShowAllPackages(true);
        }
        setPackageList(data);
      }
    } catch (error: any) {
      openNotificationWithIcon("default", error?.message);
      console.log("Somethings wrong during getting packages", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Row>
      {isShowAllPackages ? (
        <>
          <Col xs={24}>
            <Row gutter={[0,20]}>
              <Col xs={24} className="!flex-col items-center justify-center ">
                <div className="!flex justify-center">
                  <Text className="!font-bold">Paketler Listesi</Text>
                </div>
                <div className="!flex justify-center">
                  <Text className="!text-sm !text-gray-400">
                    Sizin için en iyi firsatları sunyoruz
                  </Text>
                </div>
                {packageList?.length > 0 && (
                  <>
                    <div className="!flex justify-end">
                      <MazakaButton
                        icon={<ArrowLeftOutlined />}
                        className="!bg-black !text-white"
                        onClick={() => {
                          setIsShowAllPackages(false);
                        }}
                      >
                        Aktif Pakte Dön
                      </MazakaButton>
                    </div>
                  </>
                )}
              </Col>

              <Col xs={24}>
                <Package />
              </Col>
            </Row>
          </Col>
        </>
      ) : (
        <>
          <Col xs={24}>
            <Row gutter={[0, 20]}>
              <Col xs={24} className="!flex justify-between items-center">
                <span>
                  <Tag color="green">Aktif Paket Bilgileri</Tag>
                </span>
                {packageList.length > 0 && (
                  <MazakaButton
                    icon={
                      packageList.length > 0 ? (
                        <EditOutlined />
                      ) : (
                        <PlusOutlined />
                      )
                    }
                    className="!bg-black !text-white"
                    onClick={() => {
                      setIsShowAllPackages(true);
                    }}
                  >
                    Paketi Yükselt
                  </MazakaButton>
                )}
              </Col>
              <Col xs={24}>
                <List
                  loading={isLoading}
                  dataSource={packageList}
                  bordered
                  renderItem={(item: any) => (
                    <List.Item className="!p-6" >
                      <Col xs={24}>
                        <Row>
                          <Col xs={24} lg={16}>
                            <Row gutter={[0,10]}>
                              <Col xs={24} className="!flex justify-center md:!block" >
                                <Text className="!font-bold !text-lg md:!text-2xl">
                                  {item.name}
                                </Text>
                              </Col>
                              <Col xs={24}>
                                <div className="!flex flex-col   md:!flex-row  gap-1">
                                  <span className=" ">
                                    <Tag className=" !text-white !bg-black !p-2 !rounded-md !text-xs md:!text-sm !w-full !flex justify-center md:!block">
                                      {" "}
                                      Toplam Haklarınız:{item.totalRight}
                                    </Tag>
                                  </span>
                                  <span className="" >
                                    <Tag className="!bg-[#FFC502] !text-black p-2 !rounded-md !text-xs md:!text-sm !w-full !flex justify-center md:!block ">
                                      {" "}
                                      Kalan Haklarınız :{item.remainingRight}
                                    </Tag>
                                  </span>
                                </div>
                              </Col>
                              <Col xs={24}>
                                <div className="!my-2 !flex gap-2">
                                  <p className="!text-black !text-[10px] md:!text-sm ">
                                    Başlangıç :
                                    {dayjs(item.startDate).format("DD.MM.YYYY")}
                                  </p>
                                  <SwapRightOutlined />
                                  <p className="!text-black !text-[10px] md:!text-sm ">
                                    Bitiş:
                                    {dayjs(item.endDate).format("DD.MM.YYYY")}
                                  </p>
                                </div>
                              </Col>
                              <Col xs={24} className="!flex justify-center md:!block">
                                <Text className="md:!text-sm !text-black-400 !text-xs">
                                  {item.description}
                                </Text>
                              </Col>
                            </Row>
                          </Col>
                          <Col xs={24} lg={8}>
                            <div className="!w-full !flex justify-end items-center !h-full" >
                            <span className="text-xl font-semibold">
                                  <div>
                                    {item?.priceWithDiscount > 0 &&
                                    item?.priceWithDiscount !== item?.price ? (
                                      <>
                                        <div>
                                          <Text
                                            className={`text-2xl !text-black`}
                                          >
                                            {item?.priceWithDiscount === 0 ? (
                                              <Tag
                                                color="green"
                                                className="!text-lg !p-2"
                                              >
                                                Ücretsiz
                                              </Tag>
                                            ) : (
                                              <PriceFormatter
                                                inputPrice={
                                                  item?.priceWithDiscount
                                                }
                                              />
                                            )}
                                          </Text>
                                        </div>
                                      </>
                                    ) : (
                                      <Text
                                        className={`text-xl font-bold !text-black`}
                                      >
                                        {item?.price === 0 ? (
                                          <Tag
                                            color="green"
                                            className="!text-lg !p-2"
                                          >
                                            Ücretsiz
                                          </Tag>
                                        ) : (
                                          <PriceFormatter
                                            inputPrice={item.price}
                                          />
                                        )}
                                      </Text>
                                    )}
                                  </div>
                                </span>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </List.Item>
                  )}
                />
              </Col>
            </Row>
          </Col>
        </>
      )}
    </Row>
  );
};

export default CurrentPackage;
